import { TableInputCell, TableInputChoice } from "@tellescope/types-models";
import { cn } from "@tellescope/utils";
import { InputTableCell } from "./InputTableCell";
import { Button } from "@tellescope/ui";
import { X } from "lucide-react";

export interface InputTableRowProps {
  fieldId: string;
  value: TableInputCell[];
  onChange: (value: TableInputCell[]) => void;
  onRemove?: () => void;
  columnsConfig: TableInputChoice[];
  className?: string;
}

export const InputTableRow = ({ fieldId, value, onChange, onRemove, columnsConfig, className }: InputTableRowProps) => {
  return (
    <div
      className={cn(`grid gap-1`, className)}
      style={{ gridTemplateColumns: `repeat(${columnsConfig.length}, minmax(0, 1fr)) min-content` }}
    >
      {columnsConfig.map((col, i) => {
        const val = value[i]?.entry;
        if (val === undefined) return null;
        return (
          <InputTableCell
            key={fieldId}
            id={fieldId}
            value={val}
            {...col}
            onChange={(newValue) => {
              onChange([...value.slice(0, i), { entry: newValue, label: col.label }, ...value.slice(i + 1)]);
            }}
          />
        );
      })}
      {!!onRemove && (
        <Button variant="ghost" size="icon" onClick={onRemove}>
          <X />
        </Button>
      )}
    </div>
  );
};
